<div class="menuSearchDiv">
  <vias-input [form]="form" [item]="item" [(ngModel)]="menuSearchText" (onchange)="onChangeInput($event)"  tabindex="100"></vias-input>
</div>
<div class="navigation">
  <mat-nav-list viasAccordion class="navigation">
    <div *ngFor="let menuitem of getAll() | filter : menuSearchText">
      <!-- baslik -->
      <h5 mat-subheader *ngIf="menuitem.type === mt.title">{{ menuitem.name  | translate }}</h5>

      <!-- baslik cocuklari icin -->
      <mat-list-item viasAccordionlink *ngFor="let childitem of menuitem.children">
        <!-- varsa baslik altinda link -->
        <a class="relative" [routerLink]="childitem.url" *ngIf="childitem.type === mt.link">
          <mat-icon>{{ childitem.icon }}</mat-icon>
          <span>{{ 'pageNames.page_'+childitem.pageId  | translate }}</span>
          <span fxFlex></span>
          <span class="menu-badge mat-{{ badge.type }}" *ngFor="let badge of childitem.badge">{{ badge.value }}</span>
        </a>
        <!-- varsa alt baslik -->
        <a viasAccordionToggle class="relative" href="javascript:;" *ngIf="childitem.type === mt.sub">
          <mat-icon>{{ childitem.icon }}</mat-icon>
          <span>{{ childitem.name  | translate }}</span>
          <span fxFlex></span>
          <mat-icon class="menu-caret">arrow_drop_down</mat-icon>
        </a>
        <mat-nav-list class="sub-menu" *ngIf="childitem.type === mt.sub">
          <!-- alt baslik altindaki link -->
          <mat-list-item *ngFor="let childlinks of childitem.children" routerLinkActive="open">
            <a [routerLink]="childlinks.url"
              class="relative">{{ 'pageNames.page_'+childlinks.pageId  | translate }}</a>
          </mat-list-item>
        </mat-nav-list>
      </mat-list-item>

       <!-- basliklsiz link -->
      <a class="relative" [routerLink]="menuitem.url" *ngIf="menuitem.type === mt.link">
        <mat-icon>{{ menuitem.icon }}</mat-icon>
        <span>{{ 'pageNames.page_'+menuitem.pageId  | translate }}</span>
        <span fxFlex></span>
        <span class="menu-badge mat-{{ badge.type }}" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
      </a>

      <!-- divider-->
      <mat-divider *ngIf="menuitem.type === mt.divider" class="my-1"></mat-divider>
      <br/>
    </div>
  </mat-nav-list>
</div>